module.exports = __webpack_public_path__ + "static/media/3.3e4bff47.png";